import { Component, Input, EventEmitter, Output } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaseButtonSize } from '../../../../shared/components/button/base-button.component';
import { NotificationResponse, MetaPagination } from '../../../../../api';

@Component({
  selector: 'base-notifications-dropdown',
  templateUrl: './base-notifications-dropdown.component.html',
})
export class BaseNotificationsDropdownComponent {
  @Input() totalUnreadNotifications = 0;
  @Input() unreadNotifications: Array<NotificationResponse> = [];
  @Input() allNotifications: Array<NotificationResponse> = [];
  @Input() modalRef: NgbModalRef;
  @Input() pagination: MetaPagination | undefined;

  @Output() notificationClick: EventEmitter<number | undefined> = new EventEmitter();

  buttonSize = BaseButtonSize;

  onNotificationClick(event: MouseEvent, id?: number) {
    event.preventDefault();

    this.notificationClick.emit(id);
  }

  trackByNotification(_: number, item: NotificationResponse) {
    return item.id;
  }
}
